import {
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    Button,
    Typography,
    Alert,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    DeleteSingleInstaller,
    getAllInstaller,
    installerSearchAction,
    reset,
} from "../../Redux/InstallerSlice/InstallerSlice";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { DeleteModal } from "../../Components/Modal/Modals";
import { toast } from "react-toastify";

const AllInstallers = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    //get the Utility
    useEffect(() => {
        const getInstaller = async () => {
            await dispatch(getAllInstaller());
            await dispatch(reset());
        };
        getInstaller();
    }, []);

    //get the utility
    const { installer, isLodaing, isSuccess } = useSelector(
        (state) => state.installer
    );
    const DataTable = installer?.data || [];

    // Delete Installer Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);
    const [DeleteStatus, setDeleteStatus] = useState(false);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };

    const DeleteRow = async () => {
        handleClose();

        setDeleteStatus(true);
        await dispatch(DeleteSingleInstaller(data.id));
        await dispatch(getAllInstaller(data.id));
        await dispatch(reset());
    };
    const handleDeleteInstaller = async (data) => {
        handleOpen(data);
    };

    useEffect(() => {
        console.log("Delete Success");
        if (isSuccess && DeleteStatus) {
            setDeleteStatus(false);
            toast.success("Installer Deleted Success");
            const getInstaller = async () => {
                await dispatch(getAllInstaller());
                await dispatch(reset());
            };
            getInstaller();
        }
    }, [DeleteStatus, dispatch, isSuccess]);

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Company Name </TableCell>
                                <TableCell>Phone </TableCell>
                                <TableCell align="center">
                                    {" "}
                                    Business Licence
                                </TableCell>
                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {DataTable?.map((key, index) => (
                                <TableRowStyled key={key?.id}>
                                    <TableCellStyle>{index + 1}</TableCellStyle>
                                    <TableCellStyle>{key.name}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.address}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.email}</TableCellStyle>
                                    <TableCellStyle>
                                        {key.company_name}
                                    </TableCellStyle>
                                    <TableCellStyle>{key.phone}</TableCellStyle>
                                    <TableCellStyle align="center">
                                        {key.business_licence.length}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <IconButton>
                                            <Link to={`${key.id}/adders`}>
                                                <Visibility color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton>
                                            <Link to={`edit=${key.id}`}>
                                                <Edit color="success" />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={(e) => {
                                                handleDeleteInstaller(key);
                                            }}
                                        >
                                            <Delete color="error" />
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>
                    </Table>

                    {/* delete modal  */}
                    <DeleteModal
                        open={open}
                        close={handleClose}
                        title={data?.name}
                        onClick={DeleteRow}
                        loading={isLodaing}
                    />
                </TableContainerStyled>
            )}
        </>
    );
};

export default AllInstallers;
